export default "__VITE_ASSET__BqWi5AJF__"